import {
  CLEAR_HOLIDAY_STATUS,
  CREATE_HOLIDAY_FAILURE,
  CREATE_HOLIDAY_REQUEST,
  CREATE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAILURE,
  DELETE_HOLIDAY_REQUEST,
  DELETE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAILURE,
  UPDATE_HOLIDAY_REQUEST,
  UPDATE_HOLIDAY_SUCCESS,
  FETCH_HOLIDAYS_FAILURE,
  FETCH_HOLIDAYS_REQUEST,
  FETCH_HOLIDAYS_SUCCESS
} from '../actionTypes';

export const fetchHolidaysRequest = () => ({
  type: FETCH_HOLIDAYS_REQUEST
});

export const fetchHolidaysSuccess = (holidays) => ({
  type: FETCH_HOLIDAYS_SUCCESS,
  payload: holidays
});

export const fetchHolidaysFailure = (error) => ({
  type: FETCH_HOLIDAYS_FAILURE,
  payload: error
});

export const createHolidayRequest = () => ({
  type: CREATE_HOLIDAY_REQUEST
});

export const createHolidaySuccess = (holiday) => ({
  type: CREATE_HOLIDAY_SUCCESS,
  payload: holiday
});

export const createHolidayFailure = (error) => ({
  type: CREATE_HOLIDAY_FAILURE,
  payload: error
});

export const deleteHolidayRequest = (holidayId) => ({
  type: DELETE_HOLIDAY_REQUEST,
  payload: holidayId
});

export const deleteHolidaySuccess = (holidayId) => ({
  type: DELETE_HOLIDAY_SUCCESS,
  payload: holidayId
});

export const deleteHolidayFailure = (error) => ({
  type: DELETE_HOLIDAY_FAILURE,
  payload: error
});

export const updateHolidayRequest = () => ({
  type: UPDATE_HOLIDAY_REQUEST
});

export const updateHolidaySuccess = (holiday) => ({
  type: UPDATE_HOLIDAY_SUCCESS,
  payload: holiday
});

export const updateHolidayFailure = (error) => ({
  type: UPDATE_HOLIDAY_FAILURE,
  payload: error
});

export const clearHolidayStatus = () => ({
  type: CLEAR_HOLIDAY_STATUS
});
